import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import OpenAIOutlinedSvg from "@ant-design/icons-svg/es/asn/OpenAIOutlined";
import AntdIcon from "../components/AntdIcon";
var OpenAIOutlined = function OpenAIOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: OpenAIOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  OpenAIOutlined.displayName = 'OpenAIOutlined';
}
export default /*#__PURE__*/React.forwardRef(OpenAIOutlined);